import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Container } from "@material-ui/core";
import { Grid } from "@material-ui/core";

import Heading from '../../Components/sectionHeading'
import menubk from '../../images/menubk.png'
import featureimg from '../../images/faqimg.png'


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(22),
      flexBasis: '100%',
      flexShrink: 0,
      color: '#fff'
    },
    mainAcc: {
      background: 'unset',
    },
    mainheading: {
      backgroundColor: 'unset',
      // backgroundImage: 'url('+ menubk+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom',
      backgroundSize: '100% 2px',
    
    },
  }));

const Roadmap = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState('panel4');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Container maxWidth="lg" id="faq" className="pt-5">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        className="pb-5"
        style={{position:'relative'}}
      >
        <Grid
            xs={12}
            className="mb-5"
        >
           <Heading 
               title="FAQ's"
              //  subtitle="Frequently Asked Questions"
           />
        </Grid>
        <img src={featureimg} className="img-fluid Moon---FaqImg" />

        <Grid
            xs={12}
            md={10}
            className="mx-auto"
           
        > 
           <div className={classes.root + " px-3"} >
            <Accordion 
                expanded={expanded === 'panel4'}
                onChange={handleChange('panel4')}
                className={classes.mainAcc}
                style={{
                  backgroundColor: '#ffa63f',
                  boxShadow: 'rgb(255 166 63) 0px 4px 30px'
                }}
            >
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4bh-content"
                id="panel4bh-header"
                className={classes.mainheading}
                >
                <Typography className={classes.heading} style={{color:'black'}}>How To Buy FMF ?</Typography>
                </AccordionSummary>
                <AccordionDetails className="pt-4 pb-5" style={{borderRadius: 10}}>
                <Typography className="">
                FTMMoon can be purchased here at <a href="https://spookyswap.finance/swap?outputCurrency=0xef656b9eb5a039e46d3a68a9a8614f1a40b0d77c">SpookySwap!</a>
                </Typography>
                </AccordionDetails>
            </Accordion>
            </div>
        </Grid>


        <Grid
            xs={12}
            md={10}
            className="mx-auto"
        > 
           <div className={classes.root + " px-3"}>
            <Accordion 
                expanded={expanded === 'panel5'}
                onChange={handleChange('panel5')}
                className={classes.mainAcc + " mt-4"}
                style={{
                  backgroundColor: '#ffa63f',
                  boxShadow: 'rgb(255 166 63) 0px 4px 30px'
                }}
            >
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel5bh-content"
                id="panel5bh-header"
                className={classes.mainheading}
                >
                <Typography className={classes.heading} style={{color:'black'}}>How To Receive FTM Rewards?</Typography>
                </AccordionSummary>
                <AccordionDetails className="pt-4 pb-5" style={{borderRadius: 10}}>
                  <Typography className="">
                  Your FTM rewards will be delivered automatically to your wallet. To track the amount you've accumulated simply head on over to the  Dashboard on our website .
                  </Typography>
                </AccordionDetails>
            </Accordion>
            </div>
        </Grid>


        {/* <Grid
            xs={12}
            md={10}
            className="mx-auto"
        > 
           <div className={classes.root + " px-3"}>
            <Accordion 
                expanded={expanded === 'panel6'}
                onChange={handleChange('panel6')}
                className={classes.mainAcc}
            >
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel6bh-content"
                id="panel6bh-header"
                className={classes.mainheading}
                >
                <Typography className={classes.heading}>HOW TO CHECK REWARDS?</Typography>
                </AccordionSummary>
                <AccordionDetails className="pt-4 pb-5" style={{borderRadius: 10}}>
                  <Typography className="text-light">
                    On the top-right section of our homepage you will find the "Launch Dashboard" button. This will lead you to a page that will link to your wallet and will showcase the rewards you have earned so far.
                  </Typography>
                </AccordionDetails>
            </Accordion>
            </div>
        </Grid> */}
      </Grid>
    </Container>
  );
}

export default Roadmap;
